'use strict';

(function () {

    angular.module('zp').controller('PostsGridController', postsGridController);

    /**@ngInject */
    function postsGridController($window, $state, PostsService) {

        var vm = this;

        vm.inspirations = [];

        vm.openPost = openPost;

        var width = $window.innerWidth > 1200 ? "360px" : $window.innerWidth > 700 ? "320px" : "260px";

        /** Activate function */
        (function () {
            loadInspiratrons();
        })();

        function loadInspiratrons() {
            return PostsService.getAll().then(function (response) {
                for (var i = 0; i < response.length; i++) {
                    response[i].inspStyle = getInspirationStyle(i);
                    vm.inspirations.push(response[i]);
                }
                console.log(vm.inspirations);
            });
        }

        function getInspirationStyle(index) {
            if (index == 2 || index == 3 || index == 8) {
                return {
                    width: width,
                    height: "480px",
                    display: "block"
                };
            }
            return {
                width: width,
                height: "230px",
                display: "block"
            };
        }

        function openPost(post) {
            $state.go('nav.post-item', { alias: post.alias });
        }
    }
})(window.angular);